import type { FC } from 'react';
import { EmptyState } from '@/_components/EmptyState';
import { Flex } from '@/_components/Flex';
import type { ActivitiesEmptyProps } from './ActivitiesEmpty.types';

export const ActivitiesEmpty: FC<ActivitiesEmptyProps> = () => {
  return (
    <Flex padding={12} isCentered={true}>
      <EmptyState description="No activities found." icon="file" />
    </Flex>
  );
};
